export default "__VITE_ASSET__b9cac525__"